import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCursorText = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M10 5c0-2.25 1.5-3.25 3.5-3.25h.75M10 5c0-2.25-1.5-3.25-3.5-3.25h-.75M10 5v10m0 0c0 2.25-1.5 3.25-3.5 3.25h-.75M10 15c0 2.25 1.5 3.25 3.5 3.25h.75"
	})]
});
const ForwardRef = forwardRef(SvgCursorText);
export { ForwardRef as ReactComponent };
